<template>
  <div>
      <div  class="py-1" style="border-bottom: 1px solid rgba(128, 143, 156, 0.2)">
        <div class="record-body">{{record.article}}</div>
        <div class="text-grey" style="font-size: 12px">{{newsTime}}</div>
      </div>
    </div>
</template>

<script>
var moment = require("moment-timezone");
export default {
  name: "NewsItem",
  components: { },
  props: ["record"],
  data(){
    return {
      newsTime: moment(this.record.createdAt).fromNow()
    }
  },
  mounted() {
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
  },
  methods:{
    updateTimes() {
      this.newsTime = moment(this.record.createdAt).fromNow()
    }
  },
};
</script>

<style>
</style>